import classNames from 'classnames';
import styles from './DescriptionList.module.scss';

export type DescriptionListProps = {
  layout?: 'inline' | 'horizontal' | 'responsive';
  divided?: boolean;
} & JSX.IntrinsicElements['dl'];
export const DescriptionList = ({ layout, divided, className, ...props }: DescriptionListProps) => (
  <dl
    className={classNames(
      styles.root,
      {
        [styles[layout!]]: layout,
        [styles.divided]: divided,
      },
      className
    )}
    {...props}
  />
);
